import { Card, Grid } from "@mui/material";
import Loading from "../../load/loading";
import HeaderGestorConfigs from "../../utils/headerGestorConfigs";
import { useEffect, useState } from "react";
import FotoEdit from "../../utils/fotoEdit";
import Delete from "../../utils/delete";
import RepresentanteCreateDirectorTecnico from "./representanteCreateDirectorTecnico";
import InfoFieldGroup from "../../utils/InfoField/InfoFieldGroup";
import api from "../../services/api";
import MessageSuccess from "../../messages/messageSuccess";
import MessageError from "../../messages/messageError";
import { useSelector } from "react-redux";


export default function FichaRepresentante({ representante, header, setRefresh }) {
    const user = useSelector(state => state.account.user);
    const [editDados, setEditDados] = useState('')
    const [isEdit, setIsEdit] = useState(false)
    const [openEditFoto, setOpenEditFoto] = useState(false);
    const [open, setOpen] = useState(false);
    const [openRCDT, setOpenRCDT] = useState(false);
    const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setMessageError] = useState('')

    const [municipios, setMunicipios] = useState([]);
    const [provincias, setProvincias] = useState([]);

    useEffect(() => {
        if (isEdit) {
            api.get('/provincias')
                .then(res => {
                    setProvincias(res.data.provincias);

                }).catch(err => '')
        }
    }, [isEdit])

    useEffect(() => {
        if (editDados?.provinciaId) {
            api.get(`/municipios-by-provincia/${editDados?.provinciaId}`)
                .then(res => {
                    setMunicipios(res.data.municipios);
                    setEditDados((prev) => ({ ...prev, provincia: res.data.provincia.designacao }));
                }).catch(err => 'console.log(err)')
        }
    }, [editDados?.provinciaId])

    const submitEdit = async () => {
        setOpen(true)
        setMessageSuccess('')
        setMessageError('')
        // console.log(editDados)

        await api.put('/dados-pessoais/edit', { ...editDados, dadosPessoaisId: representante?.dadosPessoais?._id, 'userId': user?._id ?? '' })
            .then(res => {
                setMessageSuccess(res.data.msg)
                // setDadosPessoais(res.data)
                setRefresh && setRefresh(res.data)
                setOpen(false)

                setIsEdit(false)

            }).catch(err => {
                setOpen(false)
                setMessageError(err.response.data.message)
            })
    }

    return (representante ?

        <Card style={{ padding: 20, minHeight: '20vh', marginBottom: 20 }}>
            {messageSuccess && <MessageSuccess message={messageSuccess} />}
            {messageError && <MessageError message={messageError} />}

            <Delete
                // open={open}
                setOpen={setOpen}
                url={'/representante/delete'}
                msg={`Tem certeza que deseja eliminar Representante ${representante?.dadosPessoais?.nome}`}
                id={representante._id}
            />

            <RepresentanteCreateDirectorTecnico
                open={openRCDT}
                setOpen={setOpenRCDT}
                representante={representante}
            />

            {header &&
                <HeaderGestorConfigs
                    menu={true}
                    configArea={'fichaRepresentante'}
                    title={isEdit ? 'EDITAR DADOS' : 'FICHA DE REPRESENTANTE'}
                    representante={representante}
                    editDados={isEdit}
                    setEditDados={setIsEdit}
                    representanteCreateDirectorTecnico={setOpenRCDT}
                    delete={setOpen}
                />
            }

            <Grid container>
                {!isEdit &&
                    <Grid item marginRight={2}>
                        <FotoEdit
                            openEditFoto={openEditFoto}
                            setOpenEditFoto={setOpenEditFoto}
                            dadosPessoal={representante?.dadosPessoais} />
                    </Grid>
                }

                <Grid xs item >
                    <InfoFieldGroup
                        submit={submitEdit}
                        data={editDados}
                        // handleChange={handleChange}
                        setIsEdit={setIsEdit}
                        isEdit={isEdit}
                        load={open}
                        fields={
                            [
                                // { label: 'Estado', value: representante?.status, editable: false,},
                                { label: 'Nome', value: representante?.dadosPessoais.nome, key: 'nome', onChange: (v) => setEditDados({ ...editDados, nome: v.target.value }) },
                                { label: 'B.I', value: representante?.dadosPessoais.numeroBI, key: 'numeroBI', onChange: (v) => setEditDados({ ...editDados, numeroBI: v.target.value }) },
                                { label: 'E-mail', value: representante?.dadosPessoais.email, key: 'email', onChange: (v) => setEditDados({ ...editDados, email: v.target.value }) },
                                { label: 'Telefone 1', value: representante?.dadosPessoais.tel1, key: 'tel1', onChange: (v) => setEditDados({ ...editDados, tel1: v.target.value }) },
                                { label: 'Telefone 2', value: representante?.dadosPessoais?.tel2 ?? '', key: 'tel2', onChange: (v) => setEditDados({ ...editDados, tel2: v.target.value }) },
                                { label: 'Província', value: representante?.dadosPessoais.provincia, key: 'provinciaId', type: 'select', options: provincias, onChange: (v) => setEditDados({ ...editDados, provinciaId: v.target.value }) },
                                { label: 'Município', value: representante?.dadosPessoais.municipio, key: 'municipio', type: 'select', options: municipios, onChange: (v) => setEditDados({ ...editDados, municipio: v.target.value }) },
                                { label: 'Bairro', value: representante?.dadosPessoais.bairro, key: 'bairro', onChange: (v) => setEditDados({ ...editDados, bairro: v.target.value }) },
                                { label: 'Rua / Avenida', value: representante?.dadosPessoais.rua, key: 'rua', onChange: (v) => setEditDados({ ...editDados, rua: v.target.value }) },
                                { label: 'Nacionalidade', value: representante?.dadosPessoais.nacionalidade, key: 'nacionalidade', onChange: (v) => setEditDados({ ...editDados, nacionalidade: v.target.value }) },
                            ]
                        } />
                </Grid>
            </Grid>
        </Card>
        :
        <Loading />
    )
}